import { render, staticRenderFns } from "./TwoColumn.vue?vue&type=template&id=4783e6a5&scoped=true&"
import script from "./TwoColumn.vue?vue&type=script&lang=ts&"
export * from "./TwoColumn.vue?vue&type=script&lang=ts&"
import style0 from "./TwoColumn.vue?vue&type=style&index=0&id=4783e6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783e6a5",
  null
  
)

export default component.exports